import React from "react";
import PropTypes from "prop-types";

import SearchInput from "components/Inputs/SearchInput/SearchInput";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

export default class TableLoader extends React.PureComponent {
  state = {
    sort: { index: 0, direction: "DESC" },
    search: undefined
  };

  handleToggleSort(index) {
    const { sort } = this.state;

    if (sort === undefined) {
      this.setState({ sort: { index: index, direction: "ASC" } });
    } else if (sort.direction === "ASC") {
      this.setState({ sort: { index: index, direction: "DESC" } });
    } else {
      this.setState({ sort: { index: index, direction: "ASC" } });
    }
  }

  render() {
    const {
      headers,
      rows,
      paddingBottom,
      height,
      label,
      autoHeight,
      hideSearch,
      selectedField,
      minHeight,
      selectAllOption,
      allValuesIncluded,
      selectAll
    } = this.props;
    const { search, sort } = this.state;

    let retRows = sort
      ? rows.sort((a, b) =>
          sort.direction === "DESC"
            ? a.data[sort.index] < b.data[sort.index]
              ? 1
              : -1
            : b.data[sort.index] < a.data[sort.index]
              ? 1
              : -1
        )
      : rows;

    retRows = search
      ? retRows.filter(
          (row) =>
            row.data.filter((rData) => ("" + rData).toLowerCase().indexOf(search.toLowerCase()) !== -1).length > 0
        )
      : retRows;

    const tableStyle = {
      paddingBottom: paddingBottom ? paddingBottom + "px" : "0px",
      height: autoHeight ? "auto" : height ? height + "px" : "calc(100vh - 630px)"
    };

    if (minHeight) {
      tableStyle.minHeight = minHeight;
    }

    return (
      <div className={styles.mainHolder}>
        {hideSearch !== true && label === undefined && selectedField === undefined && (
          <div className={styles.searchHolder}>
            <SearchInput value={search} onChange={(value) => this.setState({ search: value })} />
            {search !== undefined && search.length > 0 && (
              <div className={styles.searchCount}>{retRows.length + " / " + rows.length + " found"}</div>
            )}
          </div>
        )}
        {selectedField !== undefined && <div className={styles.smallLabel}>{selectedField.label}</div>}
        {label !== undefined && (
          <div className={styles.label} title={label}>
            {label}
          </div>
        )}
        <div className={styles.tableHolder} style={tableStyle} id={"tableScroll"}>
          <Table className="table">
            <TableHeaderRow>
              {headers.map((header, index) => (
                <TableHeaderColumn
                  key={index}
                  onClick={() => this.handleToggleSort(index)}
                  style={
                    header === "Include"
                      ? { width: "50px" }
                      : header === "Column"
                        ? { width: "50%" }
                        : header === "Type"
                          ? { width: "150px", minWidth: "150px" }
                          : { width: "auto" }
                  }
                >
                  <div className={styles.headerColumn}>
                    <div>{header}</div>
                    {index === 0 && selectAllOption && (
                      <div style={{ margin: "0px 5px" }}>
                        <input
                          type="checkbox"
                          onChange={() => {
                            selectAll && selectAll();
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          checked={allValuesIncluded}
                        />
                      </div>
                    )}
                    <div className={styles.sortIcon} style={{ opacity: sort && sort.index === index ? 1 : 0 }}>
                      <FontAwesomeIcon icon={sort && sort.direction === "ASC" ? faChevronUp : faChevronDown} />
                    </div>
                  </div>
                </TableHeaderColumn>
              ))}
            </TableHeaderRow>
            <TableBody>{retRows.map((row, index) => row.row)}</TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

export const Table = (props) => {
  return (
    <table {...props} className="table">
      {props.children}
    </table>
  );
};

export const TableHeaderRow = (props) => {
  return (
    <thead>
      <tr {...props}>{props.children}</tr>
    </thead>
  );
};

export const TableHeaderColumn = (props) => {
  return (
    <th {...props} className={styles.tableHeaderColumn}>
      {props.children}
    </th>
  );
};

export const TableBody = (props) => {
  return <tbody {...props}>{props.children}</tbody>;
};

export const TableRow = (props) => {
  const { isHighlight, ...trProps } = props;

  return (
    <tr
      {...trProps}
      className={
        (props.className ? props.className + " " + styles.tableRow : styles.tableRow) +
        " " +
        (props.isHighlight ? styles.highlightRow : "")
      }
    >
      {props.children}
    </tr>
  );
};

export const TableColumn = (props) => {
  return (
    <td {...props} className={styles.tableColumn}>
      {props.children}
    </td>
  );
};
